// src/components/housingEras.js (s110) — plain-JS helpers shared by HousingEra.jsx and
// scripts/probe-housing-era-render.mjs (Node cannot import .jsx). Six eras from the ten
// ACS bins, oldest first, each with a short legend note.
export const ERAS = [
  { label: 'Before 1940', idx: [0], note: 'wood sash and older glass' },
  { label: '1940–1959', idx: [1, 2], note: 'steel casements, early aluminium' },
  { label: '1960–1979', idx: [3, 4], note: 'aluminium sliders, often single-pane' },
  { label: '1980–1999', idx: [5, 6], note: 'double-pane units become standard' },
  { label: '2000–2009', idx: [7], note: 'vinyl frames, low-E spreading' },
  { label: '2010 or later', idx: [8, 9], note: 'low-E common: gentle cleaners only' },
];
export const fmtPct = (x) => (x > 0 && x < 1 ? '<1%' : `${Math.round(x)}%`);
export function housingEras(h) {
  return ERAS.map((e, i) => { const n = e.idx.reduce((t, k) => t + h.bins[k], 0); return { ...e, n, p: (100 * n) / h.units, shade: 0.92 - i * 0.14 }; });
}

